<script setup>
    import { useVideoModalControlsStore } from '../stores/VideoModalControls'
    import { storeToRefs } from "pinia";
    import { watch } from 'vue';
    import ModalLayout from './ModalLayout'

    const videoModalControls = useVideoModalControlsStore(),
          { modalTitle, modalEmbed, modalVisible } = storeToRefs(videoModalControls),
          { modalClose } = videoModalControls

    watch(modalVisible, (currentValue) => {
        if (currentValue) {
            document.documentElement.classList.add('scroll-lock')
        } else {
            document.documentElement.classList.remove('scroll-lock')
        }
    })
</script>

<template>
	<ModalLayout
		:open="modalVisible"
        @close="modalClose()"
	>
		<template #title>
			<h3 id="video-modal__title" class="font-bold text-sm md:text-normal lg:text-lg md:text-2xl my-0">
                {{ modalTitle }}
            </h3>
		</template>

		<div class="aspect-16-9">
			<iframe class="absolute inset-0" :src="modalEmbed" title="Video Embed" width="100%" height="100%" allowfullscreen referrerpolicy="origin"></iframe>
		</div>
	</ModalLayout>
</template>
